module.exports = __webpack_public_path__ + "img/new_delhi_lockdown_measures.90289640.png";